import React, { useEffect } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export default function GoogleLoginButton() {
  const handleCallback = async (response) => {
    const googleToken = response.credential;

    // Send token to backend
    const res = await axios.post(`${apiUrl}/auth/google`, {
      token: googleToken,
    });

    localStorage.setItem("token", res.data.jwt);
    localStorage.setItem("user", JSON.stringify(res.data.user));

    window.location.href = "/";
  };

  useEffect(() => {
    /* global google */
    if (window.google) {
      google.accounts.id.initialize({
        client_id:
          "322850624027-6vnhm3bdui6kad71svb5tnupu9pkl6tl.apps.googleusercontent.com",
        callback: handleCallback,
      });

      google.accounts.id.renderButton(document.getElementById("googleBtn"), {
        theme: "filled",
        size: "large",
        shape: "pill",
      });
    }
  }, []);

  return (
    <div className="flex justify-center mt-4">
      <div id="googleBtn"></div>
    </div>
  );
}
